// Grand Line Rentals - Car Fleet Data
// Based on 01motorsgta.ca fleet structure

export const companyInfo = {
  name: 'Grand Line Rentals',
  tagline: 'Experience Luxury Driving',
  phone: '647-972-1105',
  email: 'info@grandlinerentals.ca',
  address: 'Greater Toronto Area',
  logo: 'https://customer-assets.emergentagent.com/job_9034a07a-4789-4bdc-aff8-718bea218664/artifacts/9s6jhro_606958704_17851648170609804_2375202603487992225_n.jpg'
};

// Featured cars for homepage hero
export const featuredCars = [
  {
    id: 'range-rover-velar-featured',
    name: 'Range Rover Velar',
    price: 250,
    originalPrice: 300,
    image: '/cars/grandline_showroom_batch3_car_1.png',
    category: 'SUV',
    featured: true
  },
  {
    id: 'bmw-x6-m50i',
    name: 'BMW X6 M50I',
    price: 450,
    originalPrice: null,
    image: '/cars/grandline_showroom_batch3_car_2.png',
    category: 'SUV',
    featured: true
  }
];

export const allCars = [
  // Featured cars first
  ...featuredCars,
  
  // EXOTIC & SUPERCAR
  {
    id: 'lamborghini-urus',
    name: 'Lamborghini Urus',
    price: 1800,
    originalPrice: 2000,
    image: '/cars/grandline_showroom_batch2_car_1.png',
    category: 'Exotic'
  },
  {
    id: 'lamborghini-huracan-evo',
    name: 'Lamborghini Huracan Evo Spyder',
    price: 1800,
    originalPrice: 1900,
    image: '/cars/grandline_showroom_batch2_car_2.png',
    category: 'Exotic'
  },
  {
    id: 'lamborghini-aventador-sv',
    name: 'Lamborghini Aventador SV Roadster',
    price: 1500,
    originalPrice: null,
    image: '/cars/grandline_showroom_batch2_car_3.png',
    category: 'Exotic'
  },
  {
    id: 'lamborghini-aventador-widebody',
    name: 'Lamborghini Aventador Wide Body',
    price: 1800,
    originalPrice: null,
    image: '/cars/grandline_showroom_batch2_car_4.png',
    category: 'Exotic'
  },
  {
    id: 'mercedes-gts-edition-1',
    name: 'Mercedes-Benz GTS Edition 1',
    price: 1200,
    originalPrice: 1400,
    image: '/cars/grandline_showroom_batch2_car_5.png',
    category: 'Exotic'
  },
  
  // LUXURY
  {
    id: 'rolls-royce-ghost',
    name: 'Rolls Royce Ghost Tiffany Edition',
    price: 800,
    originalPrice: null,
    image: '/cars/grandline_showroom_batch2_car_6.png',
    category: 'Luxury'
  },
  {
    id: 'range-rover-autobiography',
    name: 'Range Rover Autobiography',
    price: 700,
    originalPrice: 800,
    image: '/cars/grandline_showroom_batch2_car_7.png',
    category: 'Luxury'
  },
  
  // SPORTS
  {
    id: 'corvette-c8',
    name: 'Corvette C8',
    price: 650,
    originalPrice: 700,
    image: '/cars/grandline_showroom_batch2_car_8.png',
    category: 'Sports'
  },
  
  // MERCEDES
  {
    id: 'mercedes-gt-53',
    name: 'Mercedes GT 53',
    price: 500,
    originalPrice: 550,
    image: '/cars/grandline_showroom_batch2_car_9.png',
    category: 'Luxury'
  },
  {
    id: 'mercedes-s63-brabus',
    name: 'Mercedes S63 Brabus Edition',
    price: 500,
    originalPrice: null,
    image: '/cars/grandline_showroom_batch2_car_10.png',
    category: 'Luxury'
  },
  {
    id: 'mercedes-s-class',
    name: 'Mercedes S-Class',
    price: 400,
    originalPrice: 450,
    image: '/cars/grandline_showroom_batch2_car_11.png',
    category: 'Luxury'
  },
  {
    id: 'mercedes-maybach',
    name: 'Mercedes Maybach',
    price: 300,
    originalPrice: null,
    image: '/cars/grandline_showroom_batch2_car_12.png',
    category: 'Luxury'
  },
  {
    id: 'mercedes-gle-53-amg',
    name: 'Mercedes GLE 53 AMG',
    price: 300,
    originalPrice: 350,
    image: '/cars/grandline_showroom_batch2_car_13.png',
    category: 'SUV'
  },
  {
    id: 'mercedes-glc-43-amg-coupe',
    name: 'Mercedes GLC 43 AMG Coupe',
    price: 280,
    originalPrice: null,
    image: '/cars/grandline_showroom_batch2_car_14.png',
    category: 'SUV'
  },
  
  // PORSCHE
  {
    id: 'porsche-cayenne',
    name: 'Porsche Cayenne',
    price: 260,
    originalPrice: 300,
    image: '/cars/grandline_showroom_batch2_car_15.png',
    category: 'SUV'
  },
  {
    id: 'porsche-macan-s',
    name: 'Porsche Macan S',
    price: 240,
    originalPrice: 275,
    image: '/cars/grandline_showroom_batch2_car_16.png',
    category: 'SUV'
  },
  {
    id: 'porsche-boxster-718',
    name: 'Porsche Boxster 718',
    price: 400,
    originalPrice: 450,
    image: '/cars/grandline_showroom_batch2_car_17.png',
    category: 'Convertible'
  },
  
  // RANGE ROVER
  {
    id: 'range-rover-sport-v8',
    name: 'Range Rover Sport V8',
    price: 300,
    originalPrice: null,
    image: '/cars/grandline_showroom_batch2_car_18.png',
    category: 'SUV'
  },
  {
    id: 'range-rover-sport',
    name: 'Range Rover Sport',
    price: 250,
    originalPrice: 300,
    image: '/cars/grandline_showroom_batch2_car_19.png',
    category: 'SUV'
  },
  {
    id: 'range-rover-velar',
    name: 'Range Rover Velar',
    price: 180,
    originalPrice: 280,
    image: '/cars/grandline_showroom_batch2_car_20.png',
    category: 'SUV'
  },
  
  // BMW
  {
    id: 'bmw-x3m-competition',
    name: 'BMW X3M Competition',
    price: 350,
    originalPrice: 400,
    image: '/cars/grandline_showroom_batch3_car_3.png',
    category: 'SUV'
  },
  {
    id: 'bmw-x5',
    name: 'BMW X5',
    price: 280,
    originalPrice: null,
    image: '/cars/grandline_showroom_batch3_car_4.png',
    category: 'SUV'
  },
  {
    id: 'bmw-x4m40',
    name: 'BMW X4M40',
    price: 250,
    originalPrice: 280,
    image: '/cars/grandline_showroom_batch3_car_5.png',
    category: 'SUV'
  },
  {
    id: 'bmw-340i',
    name: 'BMW 340i',
    price: 250,
    originalPrice: 280,
    image: '/cars/grandline_showroom_batch3_car_6.png',
    category: 'Sedan'
  },
  {
    id: 'bmw-m440',
    name: 'BMW M440',
    price: 250,
    originalPrice: 280,
    image: '/cars/grandline_showroom_batch3_car_7.png',
    category: 'Coupe'
  },
  {
    id: 'bmw-4-series',
    name: 'BMW 4 Series M Package',
    price: 200,
    originalPrice: 225,
    image: '/cars/grandline_showroom_batch3_car_8.png',
    category: 'Coupe'
  },
  {
    id: 'bmw-5-series',
    name: 'BMW 5 Series',
    price: 200,
    originalPrice: null,
    image: '/cars/grandline_showroom_batch3_car_9.png',
    category: 'Sedan'
  },
  {
    id: 'bmw-3-series',
    name: 'BMW 3 Series',
    price: 200,
    originalPrice: null,
    image: '/cars/grandline_showroom_batch3_car_10.png',
    category: 'Sedan'
  },
  
  // MERCEDES SEDANS & COUPES
  {
    id: 'mercedes-c43-blue',
    name: 'Mercedes C43 (Blue)',
    price: 250,
    originalPrice: 275,
    image: '/cars/grandline_showroom_batch3_car_11.png',
    category: 'Coupe'
  },
  {
    id: 'mercedes-c43-white',
    name: 'Mercedes C43 (White)',
    price: 250,
    originalPrice: 280,
    image: '/cars/grandline_showroom_batch3_car_12.png',
    category: 'Sedan'
  },
  {
    id: 'mercedes-c43-amg-stage2',
    name: 'Mercedes-Benz C43 AMG Stage 2',
    price: 249,
    originalPrice: 275,
    image: '/cars/grandline_showroom_batch3_car_13.png',
    category: 'Sedan'
  },
  {
    id: 'mercedes-c43-amg',
    name: 'Mercedes C43 AMG',
    price: 220,
    originalPrice: 275,
    image: '/cars/grandline_showroom_batch3_car_14.png',
    category: 'Sedan'
  },
  {
    id: 'mercedes-a35-amg',
    name: 'Mercedes A35 AMG',
    price: 220,
    originalPrice: 240,
    image: '/cars/grandline_showroom_batch3_car_15.png',
    category: 'Sedan'
  },
  {
    id: 'mercedes-glc-43-amg-tuned',
    name: 'Mercedes-Benz GLC 43 AMG Stage 2',
    price: 225,
    originalPrice: 250,
    image: '/cars/grandline_showroom_batch3_car_16.png',
    category: 'SUV'
  },
  {
    id: 'mercedes-glb-35-amg',
    name: 'Mercedes-Benz GLB 35 AMG',
    price: 200,
    originalPrice: 250,
    image: '/cars/grandline_showroom_batch3_car_17.png',
    category: 'SUV'
  },
  {
    id: 'mercedes-c300-amg',
    name: 'Mercedes C300 AMG',
    price: 200,
    originalPrice: null,
    image: '/cars/grandline_showroom_batch3_car_18.png',
    category: 'Sedan'
  },
  {
    id: 'mercedes-c300-amg-white-interior',
    name: 'Mercedes C300 AMG White Interior',
    price: 200,
    originalPrice: null,
    image: '/cars/grandline_showroom_batch3_car_19.png',
    category: 'Sedan'
  },
  {
    id: 'mercedes-e43-amg',
    name: 'Mercedes E43 AMG',
    price: 200,
    originalPrice: 250,
    image: '/cars/grandline_showroom_batch3_car_20.png',
    category: 'Sedan'
  },
  
  // AUDI
  {
    id: 'audi-s5',
    name: 'Audi S5',
    price: 225,
    originalPrice: 275,
    image: '/cars/showroom_car_big_1.png',
    category: 'Coupe'
  },
  {
    id: 'audi-a5-convertible',
    name: 'Audi A5 Convertible',
    price: 180,
    originalPrice: 200,
    image: '/cars/showroom_car_big_2.png',
    category: 'Convertible'
  },
  
  // MORE MERCEDES
  {
    id: 'mercedes-benz-a-class',
    name: 'Mercedes-Benz A Class AMG',
    price: 189,
    originalPrice: 220,
    image: '/cars/showroom_car_big_3.png',
    category: 'Sedan'
  },
  {
    id: 'mercedes-c-class-convertible',
    name: 'Mercedes C-Class Convertible',
    price: 180,
    originalPrice: 200,
    image: '/cars/showroom_car_big_4.png',
    category: 'Convertible'
  },
  {
    id: 'mercedes-glb-250',
    name: 'Mercedes GLB 250 AMG Package',
    price: 160,
    originalPrice: 180,
    image: '/cars/showroom_car_big_5.png',
    category: 'SUV'
  },
  {
    id: 'mercedes-c300-matte',
    name: 'Mercedes C300 Matte Black',
    price: 150,
    originalPrice: 180,
    image: '/cars/showroom_car_big_6.png',
    category: 'Sedan'
  },
  {
    id: 'mercedes-benz-c300',
    name: 'Mercedes-Benz C300',
    price: 150,
    originalPrice: 160,
    image: '/cars/showroom_car_big_7.png',
    category: 'Sedan'
  },
  {
    id: 'mercedes-a220-amg',
    name: 'Mercedes A220 AMG',
    price: 140,
    originalPrice: 180,
    image: '/cars/showroom_car_big_8.png',
    category: 'Sedan'
  },
  {
    id: 'c300-amg-white',
    name: 'C300 AMG White',
    price: 140,
    originalPrice: 150,
    image: '/cars/showroom_car_big_9.png',
    category: 'Sedan'
  },
  
  // OTHER VEHICLES
  {
    id: 'suburban-zl1',
    name: 'Suburban ZL1',
    price: 249,
    originalPrice: 280,
    image: '/cars/showroom_car_big_10.png',
    category: 'SUV'
  },
  {
    id: 'maserati-levante',
    name: 'Maserati Levante',
    price: 220,
    originalPrice: 275,
    image: '/cars/showroom_car_big_11.png',
    category: 'SUV'
  },
  {
    id: 'infiniti-q60-coupe',
    name: 'Infiniti Q60 Coupe Tuned',
    price: 200,
    originalPrice: 225,
    image: '/cars/showroom_car_big_12.png',
    category: 'Coupe'
  },
  {
    id: 'dodge-challenger',
    name: 'Dodge Challenger',
    price: 180,
    originalPrice: 200,
    image: '/cars/showroom_car_big_13.png',
    category: 'Sports'
  },
  {
    id: 'mustang-convertible',
    name: 'Mustang Convertible',
    price: 150,
    originalPrice: 180,
    image: '/cars/showroom_car_big_14.png',
    category: 'Convertible'
  },
  {
    id: 'ford-mustang',
    name: 'Ford Mustang',
    price: 130,
    originalPrice: 140,
    image: '/cars/showroom_car_big_15.png',
    category: 'Sports'
  },
  {
    id: 'jeep-wrangler',
    name: 'Jeep Wrangler Rubicon',
    price: 120,
    originalPrice: 200,
    image: '/cars/showroom_car_big_16.png',
    category: 'SUV'
  },
  {
    id: 'chevrolet-suburban',
    name: 'Chevrolet Suburban',
    price: 120,
    originalPrice: null,
    image: '/cars/showroom_car_big_17.png',
    category: 'SUV'
  },
  
  // ECONOMY
  {
    id: 'volkswagen-atlas',
    name: 'Volkswagen Atlas',
    price: 100,
    originalPrice: null,
    image: '/cars/showroom_car_big_18.png',
    category: 'SUV'
  },
  {
    id: 'hyundai-elantra',
    name: 'Hyundai Elantra',
    price: 80,
    originalPrice: 100,
    image: '/cars/showroom_car_big_19.png',
    category: 'Sedan'
  },
  {
    id: 'volkswagen-jetta',
    name: 'Volkswagen Jetta',
    price: 80,
    originalPrice: null,
    image: '/cars/showroom_car_big_20.png',
    category: 'Sedan'
  },
  {
    id: 'hyundai-santa-fe',
    name: 'Hyundai Santa Fe',
    price: 70,
    originalPrice: 90,
    image: '/cars/showroom_car_big_1.png',
    category: 'SUV'
  },
  {
    id: 'elantra-n-line',
    name: 'Elantra N Line',
    price: 70,
    originalPrice: 80,
    image: '/cars/showroom_car_big_2.png',
    category: 'Sedan'
  },
  {
    id: 'mitsubishi-rvr',
    name: 'Mitsubishi RVR',
    price: 70,
    originalPrice: 80,
    image: '/cars/showroom_car_big_3.png',
    category: 'SUV'
  }
];

export const categories = ['All', 'Exotic', 'Luxury', 'Sports', 'SUV', 'Sedan', 'Coupe', 'Convertible'];

export const reviews = [
  {
    id: 1,
    name: 'Michael T.',
    rating: 5,
    text: 'Amazing car selection and outstanding customer service. Will definitely rent again!',
    car: 'Lamborghini Urus'
  },
  {
    id: 2,
    name: 'Sarah K.',
    rating: 5,
    text: 'The Range Rover was perfect for our weekend getaway. Smooth booking process.',
    car: 'Range Rover Sport'
  },
  {
    id: 3,
    name: 'James L.',
    rating: 5,
    text: 'Professional service from start to finish. The BMW X6 was immaculate.',
    car: 'BMW X6 M50I'
  },
  {
    id: 4,
    name: 'Emily R.',
    rating: 5,
    text: 'Best rental experience in the GTA. Highly recommend Grand Line Rentals!',
    car: 'Mercedes GT 53'
  },
  {
    id: 5,
    name: 'David M.',
    rating: 5,
    text: 'The Corvette C8 made my birthday unforgettable. Thank you Grand Line!',
    car: 'Corvette C8'
  }
];

export const whyUsFeatures = [
  {
    title: 'Customer Service',
    description: 'Grand Line Rentals takes pride in our customer services. We provide 24/7 customer care with our dedicated team.',
    icon: 'headset'
  },
  {
    title: 'Reliability',
    description: 'All of our vehicles are always up to date with services and maintenance to ensure reliable transportation.',
    icon: 'shield-check'
  },
  {
    title: 'Insurance Coverage',
    description: "Grand Line Rentals offers insurance coverage with Canada's top rated insurance companies.",
    icon: 'file-shield'
  }
];
